import MediaCardImage1Up2UpV2 from "./media-module-coontainer";

export default MediaCardImage1Up2UpV2;
export type { IMediaModuleImageProps } from "./media-module.types";
